import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TournamentGameComponent } from './tournament-game.component';
import { TournamentGameStatisticComponent } from './tournament-game-statistic/tournament-game-statistic.component';
import { TournamentGameProtocolComponent } from './tournament-game-protocol/tournament-game-protocol.component';
import { TournamentGameTimelineComponent } from './tournament-game-timeline/tournament-game-timeline.component';
import { RouterModule } from '@angular/router';
import { ROUTES } from './tournament-game.routes';
import { TournamentGameMediaComponent } from './tournament-game-media/tournament-game-media.component';
import { TournamentGameMediaDialogComponent } from './tournament-game-media/tournament-game-media-dialog.component';
import { ButtonModule, ChipsModule, DialogModule, DropdownModule, SvgIconModule, UtilsModule } from '@mtgame/ui';
import { GameModule } from '../../shared/game/game.module';
import { TournamentMediaModule } from '../../shared/tournament-media/tournament-media.module';
import { TournamentGameLiveComponent } from './tournament-game-live/tournament-game-live.component';
import { SharedModule } from '@shared/shared.module';
import { BasketballGameModule } from '../../shared/basketball-game/basketball-game.module';
import { HockeyGameModule } from '../../shared/hockey-game/hockey-game.module';
import { VolleyballGameModule } from '../../shared/volleyball-game/volleyball-game.module';
import { FootballGameModule } from '../../shared/football-game/football-game.module';
import { HandballGameModule } from '../../shared/handball-game/handball-game.module';
import { GameRootService } from '@core/services/game-root.service';
import { gameRootFactory } from '@core/services/game-root.factory';
import { TournamentGameResolver } from './tournament-game.resolver';
import { GameStatisticService } from '@core/services/game-statistic.service';
import { gameStatisticFactory } from '@core/services/game-statistic.factory';
import { TournamentGameStatisticResolver } from './tournament-game-statistic/tournament-game-statistic.resolver';
import { GameProtocolService } from '@core/services/game-protocol.service';
import { gameProtocolFactory } from '@core/services/game-protocol.factory';
import { TournamentGameProtocolResolver } from './tournament-game-protocol/tournament-game-protocol.resolver';
import { GameTimelineService } from '@core/services/game-timeline.service';
import { gameTimelineFactory } from '@core/services/game-timeline.factory';
import { TournamentGameTimelineResolver } from './tournament-game-timeline/tournament-game-timeline.resolver';
import { HockeyGameRootService } from '@core/services/hockey-game-root.service';
import { HockeyGameStatisticService } from '@core/services/hockey-game-statistic.service';
import { BasketballGameRootService } from '@core/services/basketball-game-root.service';
import { VolleyballGameRootService } from '@core/services/volleyball-game-root.service';
import { HandballGameRootService } from '@core/services/handball-game-root.service';
import { FootballGameRootService } from '@core/services/football-game-root.service';
import { BasketballGameStatisticService } from '@core/services/basketball-game-statistic.service';
import { VolleyballGameStatisticService } from '@core/services/volleyball-game-statistic.service';
import { FootballGameStatisticService } from '@core/services/football-game-statistic.service';
import { HandballGameStatisticService } from '@core/services/handball-game-statistic.service';
import { HockeyGameProtocolService } from '@core/services/hockey-game-protocol.service';
import { BasketballGameProtocolService } from '@core/services/basketball-game-protocol.service';
import { VolleyballGameProtocolService } from '@core/services/volleyball-game-protocol.service';
import { FootballGameProtocolService } from '@core/services/football-game-protocol.service';
import { HandballGameProtocolService } from '@core/services/handball-game-protocol.service';
import { HockeyGameTimelineService } from '@core/services/hockey-game-timeline.service';
import { BasketballGameTimelineService } from '@core/services/basketball-game-timeline.service';
import { VolleyballGameTimelineService } from '@core/services/volleyball-game-timeline.service';
import { FootballGameTimelineService } from '@core/services/football-game-timeline.service';
import { HandballGameTimelineService } from '@core/services/handball-game-timeline.service';
import { RugbyGameRootService } from '@core/services/rugby-game-root.service';
import { RugbyGameStatisticService } from '@core/services/rugby-game-statistic.service';
import { RugbyGameProtocolService } from '@core/services/rugby-game-protocol.service';
import { RugbyGameTimelineService } from '@core/services/rugby-game-timeline.service';
import { RugbyGameModule } from '../../shared/rugby-game/rugby-game.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ROUTES),
    DialogModule,
    GameModule,
    TournamentMediaModule,
    SvgIconModule,
    ButtonModule,
    DropdownModule,
    ChipsModule,
    UtilsModule,
    SharedModule,
    BasketballGameModule,
    HockeyGameModule,
    VolleyballGameModule,
    FootballGameModule,
    HandballGameModule,
    RugbyGameModule,
    DialogModule,
  ],
  declarations: [
    TournamentGameComponent,
    TournamentGameStatisticComponent,
    TournamentGameProtocolComponent,
    TournamentGameTimelineComponent,
    TournamentGameMediaComponent,
    TournamentGameMediaDialogComponent,
    TournamentGameLiveComponent,
  ],
  providers: [
    BasketballGameRootService,
    HockeyGameRootService,
    VolleyballGameRootService,
    HandballGameRootService,
    FootballGameRootService,
    RugbyGameRootService,
    {
      provide: GameRootService,
      useFactory: gameRootFactory,
      deps: [Injector],
    },
    TournamentGameResolver,
    HockeyGameStatisticService,
    BasketballGameStatisticService,
    VolleyballGameStatisticService,
    FootballGameStatisticService,
    HandballGameStatisticService,
    RugbyGameStatisticService,
    {
      provide: GameStatisticService,
      useFactory: gameStatisticFactory,
      deps: [Injector],
    },
    TournamentGameStatisticResolver,
    HockeyGameProtocolService,
    BasketballGameProtocolService,
    VolleyballGameProtocolService,
    FootballGameProtocolService,
    HandballGameProtocolService,
    RugbyGameProtocolService,
    {
      provide: GameProtocolService,
      useFactory: gameProtocolFactory,
      deps: [Injector],
    },
    TournamentGameProtocolResolver,
    HockeyGameTimelineService,
    BasketballGameTimelineService,
    VolleyballGameTimelineService,
    FootballGameTimelineService,
    HandballGameTimelineService,
    RugbyGameTimelineService,
    {
      provide: GameTimelineService,
      useFactory: gameTimelineFactory,
      deps: [Injector],
    },
    TournamentGameTimelineResolver,
  ]
})
export class TournamentGameModule {}
